import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { BLOG_LINK, FAQ_LINK, FEEDBACK_LINK, HELP_CENTER_LINK, SUPPORT_LINK } from '@utils/global'

const HelpNav: React.FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.help')}</p>
      <SideNavItem
        href={HELP_CENTER_LINK}
        external
        newTab
        label={t('siteSidebar.helpCenter')}
        iconName="nf-help"
      />
      <SideNavItem
        href="/guide"
        external
        newTab
        label={t('siteSidebar.usersGuide')}
        iconName="nf-help"
      />
      <SideNavItem
        href={FAQ_LINK}
        external
        newTab
        label={t('siteSidebar.faq')}
        iconName="nf-help"
      />
      <SideNavItem
        href={SUPPORT_LINK}
        external
        newTab
        label={t('siteSidebar.support')}
        iconName="nf-feedback"
      />
      <SideNavItem
        href={FEEDBACK_LINK}
        external
        newTab
        label={t('siteSidebar.feedback')}
        iconName="nf-feedback"
      />
      <SideNavItem
        href={BLOG_LINK}
        external
        newTab
        label={t('siteSidebar.blog')}
        iconName="nf-mic"
      />
    </>
  )
}

export default HelpNav
